import ValidationError from "./ValidationError";

class RequiredError extends ValidationError {

}

export default RequiredError;
